import { notifySuccess } from 'utils/common'

class Terminal {
  constructor (data) {
    this.sn = data.sn.toString(16) // string 16进制的sn号
    this.gatewaySn = data.gatewaySn.toString(16) // string 认为最近一次是从该网关接收指令
    this.lastJoinTime = data.lastJoinTime || '' // date 上一次入网时间
    this.lastJoinSignalIntensity = data.lastJoinSignalIntensity // number 上一次入网信号强度
    this.securityVersion = data.securityVersion // number 加密版本号

    const { messageType, branchNo, versionNo } = data.nodeLoginRequest // 入网记录
    this.joinLog = {
      type: messageType, // number 指令类型 1-网关，2-节点
      branchNo: branchNo, // number 指令分支号
      versionNo: versionNo // number 指令版本号
    }
  }
}

/**
 * 获取终端列表
 * @param  {*Number} pageNo 当前页
 * @param  {*Number} pageSize 每页条数
 * @returns {Array}
 */
const mockListData = {
  records: [
    {
      sn: 268435457,
      gatewaySn: 268435457,
      lastJoinTime: 1510125344398,
      lastJoinSignalIntensity: 50,
      securityVersion: 1,
      nodeLoginRequest: {
        messageType: 2,
        branchNo: 0,
        versionNo: 0
      }
    }
  ],
  recordCount: 20
}
export const getList = async (params) => {
  // const { data: { records, recordCount } } = await axios.get('v1/sys-downs/node', { params })
  await new Promise(resolve => {
    setTimeout(() => {
      console.log(params)
      resolve()
    }, 2000)
  })
  const { records, recordCount } = mockListData
  const list = records.map(item => new Terminal(item))
  return { list, total: recordCount }
}

/**
 * 下发通用指令
 * @param {*Object} data
 */
export const sendCommonCommand = async (data) => {
  await new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 2000)
  })
  notifySuccess('下发')
}

/**
 * 获取参数
 * @param {*String} sn 16进制的sn号
 * @return {Object}
 */
export const getConfigData = async (sn) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(sn)
    }, 2000)
  })
}

/**
 * 读取策略
 * @param {*String} sn 16进制sn号
 * @return {Object}
 */
export const getStrategyData = async (sn) => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(sn)
    }, 2000)
  })
}

/**
 * 重启系统
 * @param  {*String} snHex 16进制的sn号
 * @return {Object}
 */
export const restartSystem = async (snHex) => {
  // await axios.post('v1/sys-downs/cmd/restart-system', { snHex })
  await new Promise(resolve => {
    setTimeout(() => {
      console.log(snHex)
      resolve()
    }, 2000)
  })
  notifySuccess('重启系统成功')
}

/**
 * 重启充电
 * @param  {*String} snHex 16进制的sn号
 * @return {Object}
 */
export const restartCharge = async (snHex) => {
  // await axios.post('sys-downs/cmd/restart-charge', { snHex })
  await new Promise(resolve => {
    setTimeout(() => {
      console.log(snHex)
      resolve()
    }, 2000)
  })
  notifySuccess('重启充电成功')
}
